export const SPACE_OVERVIEW = Symbol('overview');
